import Shared from "./../../shared";
import Router from "vue-router";
import { iTaskSubscriptionType, SubscriptionGroup } from "../../enums";

export class RedirectFactory {
    constructor(props) {
        switch (props.groupId) {
            case SubscriptionGroup.CheckDocument:
            case SubscriptionGroup.ReviewDocument:
            case SubscriptionGroup.ReadList:
                return new RedirectionByRoute({ url: props.url, router: props.router });
            case SubscriptionGroup.HandleToDo:
            case SubscriptionGroup.Cases:
                if (
                    props.subscriptionType == iTaskSubscriptionType.TodoItemAssignedToMe ||
                    props.subscriptionType == iTaskSubscriptionType.TodoItemAssignedToCaseOwner
                ) {
                    return new RedirectionByRoute({ url: props.url, router: props.router });
                } else {
                    return new RedirectionByLink({
                        url: props.url,
                        targetWindow: props.targetWindow,
                        subscriptionType: props.subscriptionType,
                        teamID: props.teamID
                    });
                }
            default:
                return new RedirectionByLink({
                    url: props.url,
                    targetWindow: props.targetWindow,
                    subscriptionType: props.subscriptionType,
                    teamID: props.teamID
                });
        }
    }
}

export class Redirection {
    public getRedirectInfo(): { path: string; target: string } {
        throw new Error("Method 'getRedirectInfo()' must be implemented.");
    }
}

export class RedirectionByRoute extends Redirection {
    private props: RedirectionByRouteProps;
    constructor(props) {
        super();
        this.props = props;
    }
    public getRedirectInfo(): { path: string; target: string } {
        const routeData = this.props.router.resolve({ path: this.props.url });
        return {
            path: routeData.href,
            target: "_self"
        };
    }
}

export class RedirectionByLink extends Redirection {
    private props: RedirectionByLinkProps;
    constructor(props) {
        super();
        this.props = props;
    }
    public getRedirectInfo(): { path: string; target: string } {
        let path = `${Shared.iProvaUrl}/${this.props.url}`;

        // bugfix 63154: Remove this from path because it is added correctly later in function
        path = path.replace("FromMyTaskList=True", "");

        let params = [];

        // Add SubscriptionType to the parameters
        if (path.indexOf("SubscriptionType") < 0) params.push(`SubscriptionType=${this.props.subscriptionType}`);

        // Add FromMyTaskList=1 to the parameters
        params.push("FromMyTaskList=1");

        // Add teamID if it is available
        if (this.props.teamID) params.push(`TeamID=${this.props.teamID}`);

        // Check if path already contains a query string if not add a question mark
        if (!path.includes("?")) path = `${path}?`;
        // If path already contains a query string and it does not end with a question mark, add an ampersand
        else if (!path.endsWith("?")) path = `${path}&`;

        // Create the final path with the parameters
        path = `${path}${params.join("&")}`;

        let target = this.props.targetWindow === "new_window" ? "_blank" : "_self";
        return {
            path: path,
            target: target
        };
    }
}

export interface RedirectFactoryPropsBase {
    url: string;
}

export interface RedirectionByRouteProps extends RedirectFactoryPropsBase {
    router: Router;
}

export interface RedirectionByLinkProps extends RedirectFactoryPropsBase {
    targetWindow: string;
    subscriptionType: string;
    teamID: string;
}
